import MobileDetect from "mobile-detect";

export function noop() {}

export function reflect(promise) {
  return promise.then(
    (v) => {
      return { v, status: "resolved" };
    },
    (e) => {
      return { e, status: "rejected" };
    }
  );
}

export function requiredParam(paramName = "Parameter") {
  throw new Error(`${paramName} is required!`);
}

export function isHTML(str) {
  const a = document.createElement("div");
  a.innerHTML = str;
  for (let c = a.childNodes, i = c.length; i--; ) {
    if (c[i].nodeType === 1) {
      return true;
    }
  }
  return false;
}

export function disableAllScrolling(except) {
  const allDivs = document.querySelectorAll(".overflow");
  const result = [];
  for (let i = 0; i < allDivs.length; i++) {
    if (except !== allDivs[i]) {
      result.push(allDivs[i]);
      allDivs[i].classList.remove("overflow");
    }
  }
  return result;
}

export function enableAllScrolling(allDivs) {
  for (let i = 0; i < allDivs.length; i++) {
    allDivs[i].classList.add("overflow");
  }
}

/**
 * Hack to enable scrolling when dynamicly adding content for IOS
 */
export function enableScrollingWithTimeout(div, timeout) {
  let time = 0;
  if (timeout) {
    time = timeout;
  }
  setTimeout(() => {
    enableScrolling(div);
  }, time);
}

/**
 * Hack to enable scrolling when dynamicly adding content for IOS
 */
export function enableScrolling(div) {
  if (div) {
    div.classList.remove("overflow");
    setTimeout(() => {
      div.classList.add("overflow");
    }, 100);
  }
}

/**
 * Processes a content for the alb and extras
 * @return {[type]} [description]
 */
export function getContent(
  contentItems,
  publicationPage,
  changeDropCap,
  sessionId,
  userId,
  downloadId,
  category = ""
) {
  if (!sessionId) return;
  const result = {};
  result.images = [];
  result.extras = [];
  result.extraType = null;
  result.extraPlacement = null;

  const imageViewerImageEnrichments = [];
  let imageViewerImageEnrichmentsId = 0;

  contentItems.forEach((contentItem) => {
    switch (contentItem.ContentType) {
      case "text/xml":
        result.article = contentItem;
        result.title = contentItem.Title;
        result.wordCount =
          stripHtml(contentItem.Introduction).split(" ").length +
          stripHtml(contentItem.HtmlText).split(" ").length;
        if (changeDropCap) {
          contentItem.HtmlText = addDropCap(contentItem.HtmlText);
        }
        break;
      case "graphic/jpeg": {
        const graphic = contentItem;
        // TODO
        graphic.src = generateSecureImageURL(
          "250/0",
          contentItem.ContentItemId,
          sessionId,
          userId,
          downloadId
        );
        graphic.srcHD = generateSecureImageURL(
          "0/0",
          contentItem.ContentItemId,
          sessionId,
          userId,
          downloadId
        );
        result.images.push(graphic);
        break;
      }
      case "image/jpeg": {
        const image = contentItem;
        result.images.push(image);
        break;
      }
      case "quote/xml":
        result.quote = contentItem; //TODO: quote is empty for NB
        break;
      case "author/xml":
        result.author = contentItem;
        break;
      //start extras
      case "ad/url":
        if (!result.extraType) {
          result.extraType = "url";
        } else if (result.extraType !== "url") {
          result.extraType = "mixed";
        }
        if (
          publicationPage &&
          !result.extraPlacement &&
          publicationPage.RelatedContents.some((rc) => {
            return rc.RelatedContentItemId === contentItem.ContentItemId;
          })
        ) {
          result.extraPlacement = publicationPage;
        }
        if (
          !result.extraPlacement &&
          publicationPage &&
          publicationPage.ContentItemID == contentItem.ContentItemId
        ) {
          result.extraPlacement = publicationPage;
        }

        result.extras.push(contentItem);
        break;
      case "video/url":
        if (!result.extraType) {
          result.extraType = "video";
        } else if (result.extraType !== "video") {
          result.extraType = "mixed";
        }
        if (
          publicationPage &&
          !result.extraPlacement &&
          publicationPage.RelatedContents.some((rc) => {
            return rc.RelatedContentItemId === contentItem.ContentItemId;
          })
        ) {
          result.extraPlacement = publicationPage;
        }
        result.extras.push(contentItem);
        break;
      case "imageEnrichment/jpeg": {
        if (!result.extraType) {
          result.extraType = "image";
        } else if (result.extraType !== "image") {
          result.extraType = "mixed";
        }
        if (
          publicationPage &&
          !result.extraPlacement &&
          publicationPage.RelatedContents.some((rc) => {
            return rc.RelatedContentItemId === contentItem.ContentItemId;
          })
        ) {
          result.extraPlacement = publicationPage;
        }
        const extraImage = contentItem;
        // TODO
        extraImage.src = generateSecureImageURL(
          "250/0",
          contentItem.ContentItemId,
          sessionId,
          userId,
          downloadId
        );
        extraImage.srcHD = generateSecureImageURL(
          "0/0",
          contentItem.ContentItemId,
          sessionId,
          userId,
          downloadId
        );
        extraImage.id = imageViewerImageEnrichmentsId;
        imageViewerImageEnrichmentsId++;
        imageViewerImageEnrichments.push(extraImage);
        result.extras.push(extraImage);
        break;
      }
      case "share/url":
        result.sharing = contentItem;
        break;
      default:
        // eslint-disable-next-line
        console.log(`new contentType: ${contentItem.ContentType}`);
    }
  });
  result.extraImageViewer = {};
  result.extraImageViewer.images = imageViewerImageEnrichments;
  result.category = category;
  return result;
}

/**
 * adds dropcapp class to html if only first letter is in bold tag
 */
export function addDropCap(html) {
  let result = html;
  const beginningOfHtml = result.substr(0, 15);
  let newBeginning = beginningOfHtml;
  if (
    beginningOfHtml.substr(0, 6).toLowerCase() === "<p><b>" &&
    beginningOfHtml.substr(7, 8).toLowerCase() === "</b></p>"
  ) {
    newBeginning = `<b class="dropcap">${beginningOfHtml.substr(6, 1)}</b>`;
  }
  result = newBeginning + result.substr(15);
  return result;
}

/**
 * Get the correct API endpoint for each page and environment
 * @return {[string]} the api uri
 */
function getApiEndpoint() {
  return window.location.pathname.includes("prodreader.html") ||
    window.location.pathname.includes("prod_index.html")
    ? process.env.API_ENDPOINT_PROD
    : process.env.API_ENDPOINT;
}

/**
 * generates preview URL for  given image id and size
 * @param  {[string]} size [description]
 * @param  {[int]} id   [description]
 * @return {[string]}      [description]
 */
export function generatePreview(size, id, api) {
  return `https://${api || getApiEndpoint()}/Preview/${size}/${id}`;
}

/**
 * Generates secure link that contains session data. Use this method
 * to get url for protected resources (like page images etc.)
 * @param  {string} size       image width/height
 * @param  {number} id         image identifier
 * @param  {number} sessionid  user session identifier
 * @param  {number} userid     user identifier
 * @param  {number} downloadId download identifier
 * @return {string}            secure url to resource
 */
export function generateSecurePreviewURL(
  size,
  id,
  sessionId,
  userId,
  downloadId
) {
  return `${generatePreview(size, id)}/${
    process.env.PLATFORM_VERSION
  }/${sessionId}/${userId}/${downloadId}`;
}

/**
 * generates image URL for  given image id and size
 * @param  {[string]} size [description]
 * @param  {[int]} id   [description]
 * @return {[string]}      [description]
 */
export function generateImageURL(size, id) {
  return `//${getApiEndpoint()}/Image/${size}/${id}`;
}

export function generateCoverURL(
  contentPackageId,
  size,
  thumbID,
  timestamp,
  domain = null
) {
  const targetDomain =
    domain ||
    (window.location.pathname.includes("prodreader.html") ||
    window.location.pathname.includes("prod_index.html")
      ? process.env.TARGET_DOMAIN_PROD
      : process.env.TARGET_DOMAIN);
  let time = timestamp;
  if (!time) {
    const rounding = 1000 * 60 * 1; // round by one minute
    time = Math.round(new Date().getTime() / rounding) * rounding;
  }
  return `//${targetDomain}/data/${contentPackageId}/covers/Preview-${size}-${thumbID}.jpg?t=${time}`;
}

/**
 * Generates secure link that contains session data. Use this method
 * to get url for protected images
 * @param  {string} size       image width/height
 * @param  {number} id         image identifier
 * @param  {number} sessionid  user session identifier
 * @param  {number} userid     user identifier
 * @param  {number} downloadId download identifier
 * @return {string}            secure url to resource
 */
export function generateSecureImageURL(
  size,
  id,
  sessionId,
  userId,
  downloadId
) {
  return `${generateImageURL(size, id)}/${
    process.env.PLATFORM_VERSION
  }/${sessionId}/${userId}/${downloadId}`;
}

/**
 * Generates image URL for nextgen reader
 * @param  {number} contentPackageId content package id
 * @param  {sting} fileName          file name
 * @return {string}                  URL
 */
export function generateNextgenImageUrl(contentPackageId, fileName) {
  return `//${process.env.TARGET_DOMAIN}/data/${contentPackageId}/NextGenData/${fileName}`;
}

export function createElement(name = "div") {
  return document.createElement(name);
}

export function isHighDensity() {
  return (
    (window.matchMedia &&
      (window.matchMedia(
        "only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)"
      ).matches ||
        window.matchMedia(
          "only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)"
        ).matches)) ||
    (window.devicePixelRatio && window.devicePixelRatio > 1.3)
  );
}

export function createDivWithClass(name) {
  const div = createElement();
  div.classList.add(name);
  return div;
}

export function labelToDate(dateString, language, format) {
  const moment = require("moment");
  require(`moment/locale/${language}`);
  const date = moment(dateString);
  const result = date.format(format);
  return result;
}

export function labelToShortDate(dateString, language) {
  const moment = require("moment");
  require(`moment/locale/${language}`);
  const date = moment(dateString);
  const result = date.format("ddd D MMM");
  return result;
}

export function labelToFullDate(dateString, language) {
  const moment = require("moment");
  require(`moment/locale/${language}`);
  const date = moment(dateString);
  const result = date.format("dddd D MMMM YYYY");
  return result;
}

export function goToHomeFromReader() {
  let prefix = "";
  const timestamp = Date.now();
  prefix = `../../../index.html?t=${timestamp}#`;
  window.location = prefix;
}

export function getGoToPublicationUrl(publicationData, relativeDepth = 0) {
  let postfix = "";
  let prefix = "";
  const timestamp = Date.now();
  if (process.env.NODE_ENV !== "production") {
    prefix = `/reader/reader.html?t=${timestamp}#!`;
  } else {
    prefix = `data/${publicationData.contentPackageId}/reader/reader.html?t=${timestamp}#!`;
    if (relativeDepth == 0) {
      prefix = `/${prefix}`;
    }
    for (let i = 0; i < relativeDepth; i++) {
      prefix = `../${prefix}`;
    }
  }
  if (publicationData.publicationId > 0) {
    postfix = `preferred/0/package/${publicationData.contentPackageId}/pub/${publicationData.publicationId}/page/1`;
  } else {
    postfix = `${publicationData.contentPackageId}`;
  }
  return prefix + postfix;
}

export function goToPublication(publicationData, relativeDepth = 0) {
  if (window.location.pathname.includes("prod_index.html")) {
    window.top.location = `prodreader.html?#!${publicationData.contentPackageId}`;
  } else {
    window.top.location = getGoToPublicationUrl(publicationData, relativeDepth);
  }
}

export function createSubArray(array, chunckLength) {
  if (chunckLength === 1) {
    return array.map((entry) => {
      return [entry];
    });
  }

  const sets = [];
  const length = array.length;
  const chunks = length / chunckLength;

  for (let i = 0, j = -1; i <= chunks; i += 1, j += chunckLength) {
    if (j === -1) {
      sets[i] = [null, array[0]];
    } else if (j + 1 === length) {
      sets[i] = [array[length - 1], null];
    } else {
      sets[i] = array.slice(j, j + chunckLength);
    }
  }

  return sets;
}

//reader:
//
export function createSharingUrls(
  sharingUrl,
  articleDetails,
  sharingOptions,
  isDesktop
) {
  const url = encodeURIComponent(sharingUrl);
  const shareUrls = [];
  let index = 0;
  if (sharingOptions.Facebook) {
    shareUrls.push({
      title: "Facebook",
      url: `//www.facebook.com/sharer/sharer.php?u=${url}`,
      id: index,
    });
    index++;
  }
  if (sharingOptions.WhatsApp) {
    const mailUrl = getParameterByName("url", sharingUrl);
    const watsappPrefix = isDesktop
      ? "//web.whatsapp.com/send?text="
      : "whatsapp://send?text=";
    shareUrls.push({
      title: "WhatsApp",
      url: `${watsappPrefix}${mailUrl}`,
      id: index,
    });
    index++;
  }
  if (sharingOptions.GooglePlus) {
    shareUrls.push({
      title: "GooglePlus",
      url: `//plus.google.com/share?url=${url}`,
      id: index,
    });
    index++;
  }
  if (sharingOptions.Twitter) {
    let twitParams = "";
    if (articleDetails.title) {
      twitParams = `text=${encodeURIComponent(articleDetails.title)}`;
    }

    shareUrls.push({
      title: "Twitter",
      url: `//twitter.com/intent/tweet?${twitParams}&url=${url}`,
      id: index,
    });
    index++;
  }
  if (sharingOptions.Mail) {
    let body = "";
    if (articleDetails.title) {
      body += encodeURIComponent(`${articleDetails.title} \n\n `);
    }
    if (articleDetails.intro) {
      body += encodeURIComponent(`${articleDetails.intro} \n\n `);
    }
    const mailUrl = getParameterByName("url", sharingUrl);
    shareUrls.push({
      title: "Mail",
      url: `mailto:?subject=${
        sharingOptions.MailSubject
          ? sharingOptions.MailSubject
          : sharingOptions.MailSubjectIntro + articleDetails.title
      }&body=${body}${mailUrl || sharingUrl}`,
      id: index,
    });
    index++;
  }
  return shareUrls;
}

export function getParameterByName(name, url = window.location.href) {
  const paramName = name.replace(/[\[\]]/g, "\\$&");
  const regex = new RegExp(`[?&]${paramName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
  return results[2].replace(/\+/g, " ");
}

export function removeURLParameter(parameter, url = window.location.href) {
  const urlparts = url.split("?");
  if (urlparts.length >= 2) {
    const prefix = `${encodeURIComponent(parameter)}=`;
    const pars = urlparts[1].split(/[&;]/g);
    for (let i = pars.length; i-- > 0; ) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    return urlparts[0] + (pars.length > 0 ? `?${pars.join("&")}` : "");
  }
  return url;
}

export function stripHtml(html) {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

export function getCorrectContentPackagePublication(cp) {
  //TODO: Upparcase
  return (
    cp.PublicationType === "Main" && cp.PublicationTitleFormat === "Newspaper"
  );
}

export function getFirst(data) {
  return new Promise((resolve, reject) => {
    if (data.length !== 1) {
      reject();
    } else {
      resolve(data[0]);
    }
  });
}

const systemUnavailableErrors = ["E1", "E4", "E9", "E13", "E15"];

/**
 * This method collects all the errors thrown by the RequestDownload, ValidateSubscription and ValidateSubscriptionToken
 * to generate an error message that will be translated by getErrorMessage.
 * @param {*} errorData
 */
export function generateError(errorData) {
  const data = errorData.data ? errorData.data : errorData;

  if (typeof data.StatusMessage !== "string") {
    if (errorData.call === "validateSubscription") {
      return createError(
        "VS-SM",
        "ValidateSubscription without StatusMessage",
        errorData
      );
    } else if (errorData.call === "validateSubscriptionToken") {
      return createError(
        "VST-SM",
        "ValidateSubscriptionToken without StatusMessage",
        errorData
      );
    }

    return createError(
      "RD-SM",
      "RequestDownload without StatusMessage",
      errorData
    );
  }
  let error = null;
  const message = systemUnavailableErrors.includes(data.StatusMessage)
    ? "System unavailable"
    : "";
  switch (data.StatusMessage) {
    case "E1":
    case "E4":
    case "E5":
    case "E6":
    case "E7":
    case "E8":
    case "E9":
    case "E11":
    case "E13":
    case "E15":
    case "E18":
    case "E24":
    case "E25":
    case "E26":
      error = createError(data.StatusMessage, message, errorData);
      break;

    default:
      if (errorData.call === "validateSubscription") {
        error = createError(
          "VS-KO",
          "ValidateSubscription returned an error",
          errorData
        );
      } else if (errorData.call === "validateSubscriptionToken") {
        error = createError(
          "VST-KO",
          "ValidateSubscriptionToken returned an error",
          errorData
        );
      } else if (errorData.errorType === "authentication") {
        // on a request download there can still be an authentication error
        error = createError(
          "RD-AU",
          "RequestDownload returned an authentication error",
          errorData
        );
      } else {
        error = createError(
          "RD-KO",
          "RequestDownload returned an error",
          errorData
        );
      }
  }
  return error;
}

export function getErrorMessage(error, language) {
  let message;

  if (error && error.data && error.data.CustomStatusMessage) {
    return `${error.data.CustomStatusMessage}`;
  }

  if (error && error.type) {
    switch (error.type) {
      //Errors originating from ValidateSubscription
      case "VS-ERR":
        message = validStatusMessage(error)
          ? `${language.ValidationFailed} (${error.data.StatusMessage})`
          : `${language.ValidationFailed}`;
        break;
      case "VS-SM":
        message = validStatusMessage(error)
          ? `${language.ValidationFailed} (${error.data.StatusMessage})`
          : `${language.ValidationFailed}`;
        break;

      case "E1":
      case "E4":
      case "E5":
      case "E6":
      case "E7":
      case "E8":
      case "E9":
      case "E11":
      case "E13":
      case "E15":
      case "E18":
      case "E24":
      case "E25":
      case "E26":
        message = validStatusMessage(error)
          ? `${language[error.type]} (${error.data.StatusMessage})`
          : `${language[error.type]}`;
        break;

      case "VS-KO":
        message = validStatusMessage(error)
          ? `${language.ValidationFailed} (${error.data.StatusMessage})`
          : `${language.ValidationFailed}`;
        break;

      //Errors originating from ValidateSubscriptionToken
      case "VST-ERR":
        message = validStatusMessage(error)
          ? `${language.SSOValidationFailed} (${error.data.StatusMessage})`
          : `${language.SSOValidationFailed}`;
        break;
      case "VST-SM":
        message = validStatusMessage(error)
          ? `${language.SSOValidationFailed} (${error.data.StatusMessage})`
          : `${language.SSOValidationFailed}`;
        break;
      case "VST-KO":
        message = validStatusMessage(error)
          ? `${language.SSOValidationFailed} (${error.data.StatusMessage})`
          : `${language.SSOValidationFailed}`;
        break;

      //Errors originating from RequestOrder
      case "RO-ERR":
        message = validStatusMessage(error)
          ? `${language.NewspaperCurrentlyUnavailable} (${error.data.StatusMessage})`
          : `${language.NewspaperCurrentlyUnavailable}`;
        break;
      case "RO-SM":
        message = validStatusMessage(error)
          ? `${language.NewspaperCurrentlyUnavailable} (${error.data.StatusMessage})`
          : `${language.NewspaperCurrentlyUnavailable}`;
        break;
      case "RO-KO":
        message = validStatusMessage(error)
          ? `${language.NewspaperCurrentlyUnavailable} (${error.data.StatusMessage})`
          : `${language.NewspaperCurrentlyUnavailable}`;
        break;

      //Errors originating from RequestDownload
      case "RD-AU":
        message = validStatusMessage(error)
          ? `${language.ValidationFailed} (${error.data.StatusMessage})`
          : `${language.ValidationFailed}`;
        break;
      case "RD-ERR":
        message = validStatusMessage(error)
          ? `${language.NewspaperCurrentlyUnavailable} (${error.data.StatusMessage})`
          : `${language.NewspaperCurrentlyUnavailable}`;
        break;
      case "RD-SM":
        message = validStatusMessage(error)
          ? `${language.NewspaperCurrentlyUnavailable} (${error.data.StatusMessage})`
          : `${language.NewspaperCurrentlyUnavailable}`;
        break;

      case "RD-KO":
        message = validStatusMessage(error)
          ? `${language.NewspaperCurrentlyUnavailable} (${error.data.StatusMessage})`
          : `${language.NewspaperCurrentlyUnavailable}`;
        break;

      //Errors originating from ConfirmDownload
      case "CD-ERR":
        message = validStatusMessage(error)
          ? `${language.NewspaperCurrentlyUnavailable} (${error.data.StatusMessage})`
          : `${language.NewspaperCurrentlyUnavailable}`;
        break;

      //paywall
      case "PW-FIELDS":
        message = validStatusMessage(error)
          ? `${language.PleaseFillInAllFields} (${error.data.StatusMessage})`
          : `${language.PleaseFillInAllFields}`;
        break;
      case "PW-EMAIL":
        message = validStatusMessage(error)
          ? `${language.PleaseFillInAValidEmail} (${error.data.StatusMessage})`
          : `${language.PleaseFillInAValidEmail}`;
        break;
      default:
        message =
          validStatusMessage(error) &&
          error.data.StatusMessage.toLowerCase() != "ok"
            ? `${language.UnknownError} (${error.data.StatusMessage})`
            : `${language.UnknownError}`;
    }
  } else {
    message = validStatusMessage(error)
      ? `${language.UnknownError} (${error.data.StatusMessage})`
      : `${language.UnknownError}`;
  }

  return message;
}

function validStatusMessage(error) {
  return (
    error.data &&
    error.data.StatusMessage &&
    error.data.StatusMessage != null &&
    error.data.StatusMessage.toLowerCase() != "ok"
  );
}

export function createError(type, message, data) {
  return { type, message, data };
}

export function pad(number, length) {
  let str = `${number}`;
  while (str.length < length) {
    str = `0${str}`;
  }
  return str;
}

export function constructCurrentDate() {
  const now = new Date();
  let timezoneOffset = now.getTimezoneOffset();

  timezoneOffset =
    (timezoneOffset < 0 ? "+" : "-") + // Note the reversed sign!
    pad(parseInt(Math.abs(timezoneOffset / 60), 10), 2) +
    pad(Math.abs(timezoneOffset % 60), 2);

  return `${now.getFullYear()}-${pad(now.getMonth() + 1, 2)}-${pad(
    now.getDate(),
    2
  )}T${pad(now.getHours(), 2)}:${pad(now.getMinutes(), 2)}:${pad(
    now.getSeconds(),
    2
  )}${timezoneOffset}`;
}

/**
 * Removes null or undefined elements from array
 * @param  {Array} array
 * @return {Array} array without null or undefined elements
 */
export function compact(list = []) {
  return list.reduce((acc, el) => {
    if (el !== null && el !== undefined) {
      acc.push(el);
    }
    return acc;
  }, []);
}

export function isSamsungBrowser() {
  return navigator.userAgent.indexOf("SamsungBrowser") !== -1;
}

let android = null;

export function isAndroid() {
  if (android === null) {
    android = document.body.classList.contains("AndroidOS");
  }

  return android;
}

/**
 * Check kind of device (for touch)
 *
 * possible returns:
 *
 * mobile       if mobile
 *
 * phone        if phone
 * tablet       if tablet
 *
 * kind of phone/tablet
 *    iPhone, iPad, iPod,
 *
 * browser
 *    Chrome, Safari
 *
 * OS
 *    iOS, AndroidOS
 */
export function getDeviceClasses() {
  const classNames = [];

  const md = new MobileDetect(navigator.userAgent);

  // mobile or tablet:
  if (md.mobile()) {
    classNames.push("mobile");
    if (md.phone()) {
      classNames.push("phone");
      classNames.push(md.phone());
    } else if (md.tablet()) {
      classNames.push("tablet");
      classNames.push(md.tablet());
    }
    //browser
    //  Chrome
    //  Safari
    if (md.userAgent()) {
      classNames.push(md.userAgent()); //TODO: sometimes it says it is on safari while it is not
    }
    //os
    const os = md.os();
    if (os) {
      classNames.push(os);
      if (os === "AndroidOS") {
        classNames.push(`version_${md.version("Android")}`);
      } else if (os === "iOS") {
        classNames.push(`version_${md.version("Version")}`);
      }
    }

    if (isSamsungBrowser()) {
      classNames.push("samsung-browser");
    }
  } else {
    if (navigator.platform.indexOf("Mac") > -1) {
      if (navigator.maxTouchPoints > 1 && !window.MSStream) {
        classNames.push("mobile");
        classNames.push("tablet");
        classNames.push(md.tablet());
      } else {
        classNames.push("desktop");
        classNames.push("mac");
      }
    } else {
      classNames.push("desktop");
      if (navigator.platform.indexOf("Win") > -1) {
        classNames.push("windows");
      }
      if (navigator.userAgent.indexOf("Chrome") > -1) {
        classNames.push("chrome");
      }
    }
  }

  const ua = window.navigator.userAgent;
  const msie = ua.indexOf("MSIE ");

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    // check if IE
    classNames.push("IE");
  }

  return classNames;

  //navigator:
  // appCodeName:'Mozilla'
  // appName:'Netscape'
  // appVersion:'5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/48.0.2564.23 Mobile Safari/537.36'
  // cookieEnabled:true
  // credentials:CredentialsContainer
  // doNotTrack:null
  // geolocation:Geolocation
  // hardwareConcurrency:8
  // language:'nl'
  // languages:Array[4]
  // maxTouchPoints:1
  // mediaDevices:MediaDevices
  // mimeTypes:MimeTypeArray
  // onLine:true
  // permissions:Permissions
  // platform:'Win32'
  // plugins:PluginArray
  // presentation:Presentation
  // product:'Gecko'
  // productSub:'20030107'
  // serviceWorker:ServiceWorkerContainer
  // userAgent:'Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/48.0.2564.23 Mobile Safari/537.36'
  // vendor:'Google Inc.'
  // vendorSub:''
}

/**
 * Check if tracking events is turned on
 * @return {boolean}
 */
export function areEventsTracked() {
  return !!localStorage.getItem("trackEvents");
}

/**
 * Replace a character of a string based on its index
 * @param  {[type]} string  [description]
 * @param  {[type]} index   [description]
 * @param  {[type]} replace [description]
 * @return {[type]}         [description]
 */

export function replaceAt(string, index, replace) {
  return string.substring(0, index) + replace + string.substring(index + 1);
}

/**
 * Extract the text of a string containing text and html tags.
 * e.g Title sometimes contains some html tags that are not needed for analytics
 * @param  {[type]} html [description]
 * @return {[type]}      [description]
 */

export function stripHtm(html) {
  const div = document.createElement("div");
  div.innerHTML = html;
  const title = div.textContent || div.innerText || "";
  return title.trim();
}

export function createRedirectionLogoutUrl(paywallRedirectionUrl) {
  let url = paywallRedirectionUrl;
  if (url.indexOf("{0}") > 0) {
    url = url.replace(/\{0\}/g, encodeURIComponent(location.href));
  }
  return url;
}
export function isParameterInUrl(param) {
  if (window.location.search.indexOf(param) !== -1) {
    return true;
  }
  return false;
}

export function sendMessageIfBackButtonEnabled() {
  if (window.webkit) {
    // ios
    window.webkit.messageHandlers.twipeClose.postMessage("");
  } else if (window.TwipeAndroidMessage) {
    // android
    window.TwipeAndroidMessage.twipeClose("");
  }
}

export function createRedirectionUrl(
  paywallRedirectionUrl,
  component,
  options,
  publicationData = null
) {
  let url = "";
  let link = "";
  let encodedUrl = "";
  if (publicationData) {
    link = location.origin + getGoToPublicationUrl(publicationData);
    encodedUrl = encodeURIComponent(link);
  }

  if (options.generateSSOState) {
    if (encodedUrl !== "") {
      component.createSSOStateCookie(encodedUrl);
    } else {
      /*
      create cookie to store the state and redirectUrl
      LUX authentication system can only redirect to 1 specific url (home). That url is hardcorded in their paywall Url template.
      In case the user click directly on the publication he wants to read we save that url in the cookie.
      To redirect him directly in the reader once he has been authenticate.
      */
      component.createSSOStateCookie();
    }

    url = paywallRedirectionUrl.replace(/\{0\}/g, component.getSSOState());
  } else {
    let connector = "?";
    if (paywallRedirectionUrl.match(/\?./)) {
      const splittedUrl = paywallRedirectionUrl.split("?");
      connector = splittedUrl[1] !== "" ? "&" : connector;
    }
    if (encodedUrl !== "") {
      url = `${paywallRedirectionUrl}${connector}${options.urlRedirectParameter}=${encodedUrl}`;
    } else {
      url = `${paywallRedirectionUrl}${connector}${
        options.urlRedirectParameter
      }=${encodeURIComponent(location.href)}`;
    }
  }
  return url;
}

export function isSinglePage(appState) {
  const activePages = appState.activePages;

  if (activePages.length == 1 || appState.isDoublePage == false) {
    return true;
  } else {
    return activePages[0] == null || activePages[1] == null;
  }
}

/** This utils fucntion is used to remove undesire publication format from SWMH publication name */
export function removePublicationTypeFromSWMHPublicationName(
  publicationName,
  format
) {
  if (typeof publicationName !== "string") {
    return publicationName;
  }

  switch (format.toLowerCase()) {
    case "replica":
      return trimText(publicationName, "- replica");

    case "nextgen":
      return trimText(publicationName, "- nextgen");

    default:
      return publicationName;
  }
}

function trimText(text, textToRemove) {
  const textToRemoveIndex = text.toLowerCase().indexOf(textToRemove);
  if (textToRemoveIndex > 0) {
    return text.substring(0, textToRemoveIndex).trimEnd();
  }
  return text;
}
/**
 * This method is used by testers to check events implementation. Check docs:
 * http://confluence.twipemobile.net/display/PLT/Analytics+implementation
 * @param  {boolean} shouldTrack
 */
if (typeof window !== "undefined") {
  // fix unit tests
  window.webappTrackEvents = function webappTrackEvents(shouldTrack) {
    if (shouldTrack) {
      localStorage.setItem("trackEvents", true);
    } else {
      localStorage.removeItem("trackEvents", false);
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/utilities/utils.js